import { render, staticRenderFns } from "./DetailsReportVisita.vue?vue&type=template&id=f8fd8f24&scoped=true&"
import script from "./DetailsReportVisita.vue?vue&type=script&lang=ts&"
export * from "./DetailsReportVisita.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsReportVisita.vue?vue&type=style&index=0&id=f8fd8f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fd8f24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow})
